import JobTitleMediaContainer from './JobTitleMediaContainer';

export default JobTitleMediaContainer;
